import React, { useState, useEffect } from "react";
import { FaArrowLeftLong, FaArrowRightLong } from "react-icons/fa6";
import { FaPlay, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import FollowUs from "../Footer/FollowUs";
import LetsGet from "../Footer/LetsGet";
import { motion } from "framer-motion";

/* ============== IMAGE CAROUSEL =============== */
const Slide = ({ isActive, imgSrc, heading, subtext }) => (
  <div
    className={`absolute inset-0 transition-opacity duration-700 ${isActive ? "opacity-100 z-10" : "opacity-0 z-0"
      }`}
  >
    <img src={imgSrc} alt={heading} className="w-full h-full object-cover" />
    <div className="absolute inset-0 flex justify-center items-end bg-black/30">
      <div className="heading px-6 sm:px-10 lg:px-20 pb-16 text-white">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl max-w-4xl leading-snug">
          {heading}
        </h2>
        <p className="mt-6 text-sm sm:text-base uppercase tracking-widest opacity-80">
          {subtext}
        </p>
      </div>
    </div>
  </div>
);

/* ================= VIDEO CAROUSEL ================= */
const videos = [
  {
    id: "fz1jy4nvHRY",
    heading: "SYGNET JEWELS",
    description:
      "SYGNET JEWELS CRAFTS TIMELESS ELEGANT JEWELLERY WITH REFINED ARTISTRY.",
    thumbnail:
      "https://res.cloudinary.com/worldpackers/image/upload/c_fill,f_auto,q_auto,w_1024/v1/guides/article_cover/uohwa6ywkkdknytdxbzc",
  },
  {
    id: "b6sHpwJ2JoA",
    heading: "LUXURY COLLECTION",
    description:
      "EXPERIENCE CONTEMPORARY DESIGN BLENDED WITH CLASSIC SOPHISTICATION.",
    thumbnail:
      "https://img.redbull.com/images/c_crop,x_0,y_0,h_5301,w_7952/c_fill,w_1500,h_1000/q_auto,f_auto/redbullcom/2018/07/17/fd149ffc-bac2-411c-b2db-27d9fa0632a1/travel-collection",
  },
];


// animation
// const fadeUp = {
//   hidden: { opacity: 0, y: 80 },
//   visible: {
//     opacity: 1,
//     y: 0,
//     transition: { duration: 0.9, ease: "easeOut" },
//   },
// };
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 40,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.6,
      ease: "easeOut",
    },
  },
};

const fadeLeft = {
  hidden: { opacity: 0, x: -80 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 1.5, ease: "easeOut" },
  },
};

const fadeRight = {
  hidden: { opacity: 0, x: 80 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 1.5, ease: "easeOut" },
  },
};


const Brand = () => {
  /* ================= IMAGE CAROUSEL ================= */
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % 3);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const nextImage = () => setCurrentImage((prev) => (prev + 1) % 3);
  const prevImage = () => setCurrentImage((prev) => (prev - 1 + 3) % 3);

  /* ================= VIDEO CAROUSEL ================= */
  const [activeIndex, setActiveIndex] = useState(0);
  const [playingVideo, setPlayingVideo] = useState(null);

  const currentVideo = videos[activeIndex];

  const next = () => {
    setPlayingVideo(null);
    setActiveIndex((prev) => (prev + 1) % videos.length);
  };

  const prev = () => {
    setPlayingVideo(null);
    setActiveIndex((prev) =>
      prev === 0 ? videos.length - 1 : prev - 1
    );
  };

  // 
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    // <div className="w-full min-h-screen bg-white">
    <div className="w-full min-h-screen bg-white overflow-x-hidden">
      <Header />

      <div className="py-20">
        <div className="grid grid-cols-1 lg:grid-cols-[40%_60%] min-h-[98vh] md:min-h-[70vh] lg:min-h-[93vh] ">
          {/* LEFT ORANGE */}
          <div className="bg-[#F56E0F] text-black flex flex-col justify-between p-6 sm:p-10 lg:p-14">
          {/* <motion.div
            variants={fadeLeft}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="bg-[#F56E0F] text-black flex flex-col justify-between p-6 sm:p-10 lg:p-14"
          > */}
            {/* <div> */}
            <motion.div
              variants={fadeLeft}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
            >
              <h1 className="heading text-2xl sm:text-3xl lg:text-4xl uppercase leading-tight max-w-md">
                Build a Brand That People Remember. And Choose.
              </h1>
              <button className="group focus:outline-none mt-10">
                <svg viewBox="0 0 400 160" className="w-64 h-24">
                  <ellipse
                    cx="100"
                    cy="80"
                    rx="90"
                    ry="40"
                    className="fill-[#0F0F0F] stroke-[#F56E0F] stroke-[4] transition group-hover:fill-[#F56E0F] group-hover:stroke-[#0F0F0F]"
                  />
                  <text
                    x="100"
                    y="95"
                    textAnchor="middle"
                    className="fill-[#F56E0F] heading text-5xl uppercase pointer-events-none transition group-hover:fill-[#0F0F0F]"
                  >
                    I'm In
                  </text>
                </svg>
              </button>
              </motion.div>
            {/* </div> */}
            {/* </motion.div> */}
          </div>

          <div className="relative w-full h-[40vh] lg:h-auto">
          {/* <motion.div
              variants={fadeRight}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              className="relative w-full h-[40vh] lg:h-auto"
            > */}
            <img
              src="https://www.lucariscrystal.com/wp-content/uploads/2023/12/Sangria-in-Lucaris-Crystal-Desire-Universal-GlassSangria-in-Lucaris-Crystal-Desire-Universal-Glass-copy-3_V1.jpg"
              alt="Brand"
              className="absolute inset-0 w-full h-full object-cover"
            />
            {/* </motion.div> */} 
          </div>
        </div>

        <div className="px-6 sm:px-10 lg:px-14 py-10">
          {/* <p className="heading text-xl sm:text-2xl lg:text-5xl uppercase">
            Your brand is more than a logo, it’s the story people believe, the
            feeling they
            <br className="hidden xl:block" />
            trust, and the identity that sets you apart. We help businesses
            transform
            <br className="hidden xl:block" />
            ideas into magnetic brands
          </p> */}
          {/* <p className="heading text-xl sm:text-2xl lg:text-5xl uppercase leading-relaxed lg:leading-[1.4]"> */}
          {/* <motion.p
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="heading text-xl sm:text-2xl lg:text-5xl uppercase leading-relaxed lg:leading-[1.4]"
          >
            Your brand is more than a logo, it’s the story people believe, the
            feeling they
            <br className="hidden  lg:hidden xl:block md:block" />
            trust, and the identity that sets you apart. We help businesses
            transform
            <br className="hidden lg:hidden xl:block md:block" />
            ideas into magnetic brands
          </motion.p> */}
          <motion.p
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            className="heading text-xl sm:text-2xl lg:text-5xl uppercase leading-relaxed lg:leading-[1.4]"
          >
            Your brand is more than a logo, it’s the story people believe, the feeling they
            <br className="hidden lg:hidden xl:block md:block" />
            trust, and the identity that sets you apart. We help businesses transform
            <br className="hidden lg:hidden xl:block md:block" />
            ideas into magnetic brands
          </motion.p>
          {/* </p> */}

          <button className="group focus:outline-none mt-10">
            <svg viewBox="0 0 400 160" className="w-64 h-24">
              <ellipse
                cx="100"
                cy="80"
                rx="90"
                ry="40"
                className="fill-white stroke-[#0F0F0F] stroke-[4] transition group-hover:fill-[#0F0F0F]"
              />
              <text
                x="100"
                y="95"
                textAnchor="middle"
                className="fill-[#0F0F0F] heading text-4xl uppercase pointer-events-none transition group-hover:fill-white"
              >
                About Us
              </text>
            </svg>
          </button>
        </div>
      </div>

      {/* ================= IMAGE CAROUSEL ================= */}
      <div className="relative w-full h-screen overflow-hidden">
        <Slide
          isActive={currentImage === 0}
          imgSrc="https://maag.codesupply.co/design-architecture/wp-content/uploads/sites/4/2024/04/demo-image-0016-1400x788.webp"
          heading="SV PATEL"
          subtext="A timeless jewellery brand crafting elegance through tradition and artistry."
        />
        <Slide
          isActive={currentImage === 1}
          imgSrc="https://worldbranddesign.com/wp-content/uploads/2024/08/1-Carousel-Interiors-logo-on-Image-iOS.jpg"
          heading="SYGNET JEWELS"
          subtext="Sygnet Jewels crafts timeless elegant jewellery with refined artistry."
        />
        <Slide
          isActive={currentImage === 2}
          imgSrc="https://www.lucariscrystal.com/wp-content/uploads/2023/12/Sangria-in-Lucaris-Crystal-Desire-Universal-GlassSangria-in-Lucaris-Crystal-Desire-Universal-Glass-copy-3_V1.jpg"
          heading="Lucaris Crystal"
          subtext="Build a Brand That People Remember. And Choose."
        />
        <Slide
          isActive={currentImage === 3}
          imgSrc="https://www.lucariscrystal.com/wp-content/uploads/2023/12/Ambience-picture-of-Lucaris-Crystal-Hong-Kong-Hip-Burgundy-Glass.jpg"
          heading="Placeholder Slide"
          subtext="Your brand is more than a logo, it’s the story people believe."
        />

        <button
          onClick={prevImage}
          className="absolute left-10 bottom-10 -translate-y-1/2 text-[#F56E0F] text-2xl z-20 transition"
        >
          <FaArrowLeftLong />
        </button>
        <button
          onClick={nextImage}
          className="absolute right-10 bottom-10 -translate-y-1/2 text-[#F56E0F] text-2xl z-20 transition"
        >
          <FaArrowRightLong />
        </button>
      </div>

      {/* ================= VIDEO CAROUSEL  ================= */}
      {/* <div className="bg-white flex flex-col items-center py-20 space-y-6">

        <div className="bg-white lg:min-w-[40%] md:min-w-[60%] min-w-[90%] min-h-[350px] lg:min-h-[500px] relative flex flex-col shadow-inner overflow-hidden">

          <div className="absolute top-0 left-0 w-full h-8 bg-gradient-to-b from-black/50 to-transparent z-10"></div>

          <h2 className="heading text-left px-4 text-xl md:text-5xl z-20 text-black">
            {videoSlides[currentVideo].brand}
          </h2>

          <div
            className="flex-grow flex items-center justify-center relative "
            onClick={() => {
              if (!videoRef.current) return;
              if (isPlaying) {
                videoRef.current.pause();
              }
            }}
          >
            <video
              key={currentVideo}
              ref={videoRef}
              src={videoSlides[currentVideo].src}
              className="w-full h-full object-contain"
              autoPlay
              loop
              muted
              onPlay={() => setIsPlaying(true)}
              onPause={() => setIsPlaying(false)}
            />

            {!isPlaying && (
              <div className="absolute inset-0 flex items-center justify-center z-30">
                <button
                  onClick={(e) => {
                    e.stopPropagation(); 
                    videoRef.current.play();
                  }}
                  className="text-white text-xl bg-[#F56E0F] p-3 rounded-md transition"
                >
                  <FaPlay />
                </button>
              </div>
            )}
          </div>

          <div className="absolute bottom-0 left-0 w-full h-8 bg-gradient-to-t from-black/50 to-transparent z-10"></div>

          <div className="absolute bottom-4 left-0 w-full flex justify-between px-4 z-20">
            <button
              onClick={prevVideo}
              className="text-[#F56E0F] hover:text-gray-700 transition text-2xl"
            >
              <FaArrowLeftLong />
            </button>
            <button
              onClick={nextVideo}
              className="text-[#F56E0F] hover:text-gray-700 transition text-2xl"
            >
              <FaArrowRightLong />
            </button>
          </div>

        </div>

        <div className="">
          <p className="heading px-2 text-black text-lg md:text-2xl">{videoSlides[currentVideo].content}</p>
        </div>
      </div> */}

      <div className="relative w-full bg-white py-12">
      <div className="relative max-w-4xl mx-auto px-4">
        {/* <div className="relative h-[400px] lg:h-[500px] overflow-hidden"> */}
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="relative h-[400px] lg:h-[500px] overflow-hidden"
        >

          {playingVideo ? (
            <iframe
              className="w-full h-full"
              src={`https://www.youtube.com/embed/${playingVideo}?autoplay=1&controls=1`}
              title="YouTube video"
              allow="autoplay; encrypted-media; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <div
              className="relative w-full h-full bg-cover bg-center"
              style={{ backgroundImage: `url(${currentVideo.thumbnail})` }}
            >
              <div className="absolute inset-0 bg-black/40"></div>

              <h2 className="absolute top-6 left-6 text-white text-xl tracking-widest font-semibold">
                {currentVideo.heading}
              </h2>

              <div className="absolute inset-0 flex flex-col items-center justify-center text-white">
                <button
                  onClick={() => setPlayingVideo(currentVideo.id)}
                  className="bg-[#F56E0F] p-4 hover:scale-110 transition"
                >
                  <FaPlay className="text-white text-3xl ml-1" />
                </button>
              </div>

              <button
                onClick={prev}
                className="absolute left-6 bottom-6 text-[#F56E0F] text-3xl"
              >
                <FaChevronLeft />
              </button>

              <button
                onClick={next}
                className="absolute right-6 bottom-6 text-[#F56E0F] text-3xl"
              >
                <FaChevronRight />
              </button>
            </div>
          )}
          </motion.div>
        {/* </div> */}
        <p className="mt-6 text-center text-sm tracking-wide font-medium">
          {currentVideo.description}
        </p>
      </div>
    </div>


      <div className="bg-[#F56E0F] py-20 px-6 sm:px-10 lg:px-20 mb-0">

        <div className="max-w-7xl mx-auto space-y-10">

          {/* ===== 1 ===== */}
          <div>
            {/* <div
              onClick={() => toggleAccordion(0)}
              className="flex items-center justify-between cursor-pointer"
            >
              <h2 className="heading text-2xl sm:text-5xl lg:text-[90px] uppercase text-[#593013]">
                Brand Strategy
              </h2>

              <span
                className={`w-12 h-12 rounded-full border flex items-center justify-center text-5xl
                  ${openIndex === 0
                    ? "bg-white border-orange-500 text-orange-500"  
                    : "bg-white border-white text-black"              
                  }`}
              >
                {openIndex === 0 ? "−" : "+"}
              </span>

            </div> */}
            <div
              onClick={() => toggleAccordion(0)}
              className="group flex items-center justify-between cursor-pointer"
            >
              <h2
                className={`heading text-2xl sm:text-5xl lg:text-[90px] uppercase transition-colors duration-300
                  ${
                    openIndex === 0
                      ? "text-black"                      
                      : "text-[#593013] group-hover:text-black"
                  }`}
              >
                Brand Strategy
              </h2>

              <span
                className={`w-12 h-12 rounded-full border flex items-center justify-center text-5xl
                  ${
                    openIndex === 0
                      ? "bg-white border-orange-500 text-orange-500"
                      : "bg-white border-white text-black"
                  }`}
              >
                {openIndex === 0 ? "−" : "+"}
              </span>
            </div>

            <div
              className={`overflow-hidden transition-all duration-500 ease-in-out ${openIndex === 0 ? "max-h-40 opacity-100 mt-6" : "max-h-0 opacity-0"
                }`}
            >
              <p className="max-w-3xl text-white text-base sm:text-lg">
                We define your brand’s direction, positioning, voice, and long-term
                vision so it connects emotionally and performs commercially.
              </p>
            </div>
          </div>

          {/* ===== 2 ===== */}
          <div>
            <div
              onClick={() => toggleAccordion(1)}
              className="group flex items-center justify-between cursor-pointer"
            >
              <h2
                className={`heading text-2xl sm:text-5xl lg:text-[90px] uppercase transition-colors duration-300
                  ${
                    openIndex === 1
                      ? "text-black"                      
                      : "text-[#593013] group-hover:text-black"
                  }`}
              >
                Brand Identity Designy
              </h2>

              <span
                className={`w-12 h-12 rounded-full border flex items-center justify-center text-5xl
                  ${
                    openIndex === 1
                      ? "bg-white border-orange-500 text-orange-500"
                      : "bg-white border-white text-black"
                  }`}
              >
                {openIndex === 1 ? "−" : "+"}
              </span>
            </div>

            <div
              className={`overflow-hidden transition-all duration-500 ease-in-out ${openIndex === 1 ? "max-h-40 opacity-100 mt-6" : "max-h-0 opacity-0"
                }`}
            >
              <p className="max-w-3xl text-white text-base sm:text-lg">
                Logos, typography, color systems, and visual language that make your
                brand instantly recognizable and memorable.
              </p>
            </div>
          </div>

          {/* ===== 3 ===== */}
          <div>
            <div
              onClick={() => toggleAccordion(2)}
              className="group flex items-center justify-between cursor-pointer"
            >
              <h2
                className={`heading text-2xl sm:text-5xl lg:text-[90px] uppercase transition-colors duration-300
                  ${
                    openIndex === 2
                      ? "text-black"                      
                      : "text-[#593013] group-hover:text-black"
                  }`}
              >
                Brand Story & Messaging
              </h2>

              <span
                className={`w-12 h-12 rounded-full border flex items-center justify-center text-5xl
                  ${
                    openIndex === 2
                      ? "bg-white border-orange-500 text-orange-500"
                      : "bg-white border-white text-black"
                  }`}
              >
                {openIndex === 2 ? "−" : "+"}
              </span>
            </div>

            <div
              className={`overflow-hidden transition-all duration-500 ease-in-out ${openIndex === 2 ? "max-h-40 opacity-100 mt-6" : "max-h-0 opacity-0"
                }`}
            >
              <p className="max-w-3xl text-white text-base sm:text-lg">
                We craft narratives and messaging frameworks that communicate who you
                are, why you exist, and why people should care.
              </p>
            </div>
          </div>

          {/* ===== 4 ===== */}
          <div>
            <div
              onClick={() => toggleAccordion(3)}
              className="group flex items-center justify-between cursor-pointer"
            >
              <h2
                className={`heading text-2xl sm:text-5xl lg:text-[90px] uppercase transition-colors duration-300
                  ${
                    openIndex === 3
                      ? "text-black"                      
                      : "text-[#593013] group-hover:text-black"
                  }`}
              >
                Brand Launch & Rollout
              </h2>

              <span
                className={`w-12 h-12 rounded-full border flex items-center justify-center text-5xl
                  ${
                    openIndex === 3
                      ? "bg-white border-orange-500 text-orange-500"
                      : "bg-white border-white text-black"
                  }`}
              >
                {openIndex === 3 ? "−" : "+"}
              </span>
            </div>

            <div
              className={`overflow-hidden transition-all duration-500 ease-in-out ${openIndex === 3 ? "max-h-40 opacity-100 mt-6" : "max-h-0 opacity-0"
                }`}
            >
              <p className="max-w-3xl text-white text-base sm:text-lg">
                From internal alignment to market launch, we ensure your brand enters
                the world with clarity, consistency, and impact.
              </p>
            </div>
          </div>

        </div>
      </div>

      <div className="w-full bg-white mb-5">

        <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[80vh]">

          {/* <div className="flex items-start px-6 sm:px-10 lg:px-20 py-16"> */}
          <motion.div
            variants={fadeLeft}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="flex items-start px-6 sm:px-10 lg:px-20 py-16"
          >

            <p className="heading text-[#000000] text-xl sm:text-2xl lg:text-4xl uppercase leading-relaxed lg:leading-[1.4] max-w-xl">
              Tell us your vision, and we’ll bring it to life with strategy, design,
              and storytelling that truly represents who you are.
            </p>
          </motion.div>  
          {/* </div> */}

          {/* <div className="relative w-full h-[50vh] lg:h-auto"> */}
          <motion.div
            variants={fadeRight}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="relative w-full h-[50vh] lg:h-auto"
          >
            <img
              src="https://img.freepik.com/premium-photo/close-up-hand-holding-glass_1048944-17827927.jpg?semt=ais_hybrid&w=740&q=80"
              alt="Vision"
              className="absolute inset-0 w-full h-full object-cover"
            />
           </motion.div> 
          {/* </div> */}
        </div>
      </div>

      <LetsGet />
      <FollowUs />
      <Footer />
    </div>
  );
};

export default Brand;
